import { Fragment } from "preact";
import CouponCodeMini from "../../../../components/coupon-code";
import { affiliateMerchants } from "../../../../components/link";

const config = {
  brand: "BLUETTI",
  linkText: "BLUETTI",
  affiliateData: affiliateMerchants.bluetti,
  icon: "Bluetti",
  code: "TYGEARLAB",
  regions: ["United States", "Canada", "Australia", "New Zealand", "Japan"],
  terms:
    "Valid on all products excluding excludes accessories and flash sale items.",
  deal: "5% Off BLUETTI Discount Code",
  expiration: "2027-12-31",
};

const BluettiCouponCode = ({
  href,
  buttonText,
  full = false,
  showRegions = false,
}) => {
  return (
    <CouponCodeMini
      full={full}
      showRegions={showRegions}
      brand={config.brand}
      code={config.code}
      deal={config.deal}
      dealShort={
        <Fragment>
          an <strong>extra 5% off</strong>
        </Fragment>
      }
      terms={config.terms}
      regions={config.regions}
      expiration={config.expiration}
      linkData={{
        affiliateData: config.affiliateData,
        href: href,
        children: config.linkText,
        icon: config.icon,
        shopify: true,
      }}
      buttonText={buttonText}
    />
  );
};

export default BluettiCouponCode;
